import styled, { css } from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

// ENUMS
import { TooltipOrigins } from '../../enums/tooltips';

// INTERFACES
import { ITooltip } from '../../interfaces/Tooltip.interface';

export const isResponsiveFunction = (): boolean => {
  return typeof window !== 'undefined' && window.matchMedia('(max-width: 1400px)').matches;
};

export const Container = styled.div<ITooltip>`
  position: relative;

  ${({ origin }) =>
    origin == TooltipOrigins.CARD &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    `}

  ${({ origin, active }) =>
    origin == TooltipOrigins.CARD &&
    active &&
    css`
      &:hover span {
        opacity: 1;
        visibility: visible;
      }
    `}

    ${({ origin, active }) =>
      origin != TooltipOrigins.CARD &&
      css`
        &:hover span {
          opacity: 1;
          visibility: visible;
        }
      `}    
`;

export const TooltipContent = styled.span<ITooltip>`
    opacity: 0;
    visibility: hidden;
    
    background: ${theme.colors.primary.black};
    padding: 8px;
    border-radius: 4px;
    font-size: ${({ origin }) =>
      origin === TooltipOrigins.ICON ? '11px' : origin === TooltipOrigins.CARD ? '10px' : '14px'};
    font-family: 'Clan Pro', sans-serif;
    font-weight: ${theme.weights.semibold};
    transition: opacity 0.4s;
    position: absolute;
    bottom:  ${({ origin }) => (origin === TooltipOrigins.CARD ? 'calc(100% + 24px)' : 'calc(100% + 10px)')};
    overflow: visible;
    white-space: ${({ origin }) => (origin === TooltipOrigins.ICON ? 'pre-line' : 'nowrap')};
    line-height: 1.6vh;
    z-index: 99999;

    ${({ origin, length }) =>
      origin == TooltipOrigins.LIST &&
      `
        width: calc(100% + ${`${length}%`});
      `}

    width: ${({ origin, length }) =>
      origin === TooltipOrigins.LIST
        ? `calc(100% + ${length}%)`
        : origin === TooltipOrigins.ICON || origin === TooltipOrigins.CARD
        ? '216px '
        : origin === TooltipOrigins.TIMELINE
        ? '140px'
        : ''};

    left: ${({ percentAlignSpan }) => percentAlignSpan};
    transform: translateX(-50%);
    display: flex;
    justify-content: center;

    color: ${theme.colors.primary.white};
    white-space: pre-line;

    &::before {
      content: '';
      border-style: solid;
      border-color: ${theme.colors.primary.black} transparent;
      border-width: 8px 8px 0 8px;
      top: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }`;
